<script>
    import R, {LOADER} from "../lib/requests";
    import {SERVICE_CUSTOM_FIELDS} from "../lib/constants";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import Icon from "../components/Icon.svelte";
    import {copyObject, setFocusTo} from "../lib/lib";
    import {clickOutside} from '../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';

    export let field;

    let editField = null;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            cancelEdit();
        }
    }

    const save = () => {
        const onSuccess = result => {
            console.log("save", result);
            field.id = result.id;
            field.name = result.name;
            field.field_type_id = result.field_type_id;
            Notifier.showMessage("Το πεδίο ενημερώθηκε");
        }

        const onFailure = err => {
            Alert.warning("Πεδίο Υπηρεσίας", err.message);
        };

        if (!editField.name) {
            return;
        }

        if (editField.name === field.name && editField.field_type_id === field.field_type_id) {
            return;
        }

        let action = editField.id > 0 ? 'fieldEdit' : 'fieldCreate';
        R.handle(R.ws_service[action], editField, onSuccess, onFailure, LOADER.POPUP);
    }

    const onEdit = () => {
        console.log("onEdit");
        field.on_edit = true;
        editField = copyObject(field);
        editField.field_type_id = ~~editField.field_type_id;
        setFocusTo(`fieldName-${field.id}`);
        console.log(editField);
        document.addEventListener('keydown', handleEscapeKey);
    }

    const cancelEdit = () => {
        editField = null;
        delete (field.on_edit);
        document.removeEventListener('keydown', handleEscapeKey);
        if (field.id === 0) {
            dispatch('delete', field);
        }
    }

    const onDelete = () => {
        if (field.id === 0) {
            dispatch('delete', field);
            return;
        }

        Alert.delete("Πεδίο", `Να διαγραφεί το πεδίο "${field.name}";`, () => {
            dispatch('delete', field);
        });
    }

    const onNameKeyup = (event) => {
        if (event.key === 'Enter') {
            save();
            cancelEdit();
        }
    }

    const onClickOutside = () => {
        if (editField) {
            cancelEdit();
        }
    }

    $: if (field.on_edit && !editField) {
        onEdit();
    }
</script>

{#if field}
    <div class="field" use:clickOutside on:click_outside="{ onClickOutside }">
        {#if editField}
            <div class="field-content mt-1 mb-1 me-1">
                <input type="text" class="form-control" id="fieldName-{ field.id }" bind:value="{ editField.name }"
                       on:change="{ save }" on:keyup="{ onNameKeyup }" placeholder="όνομα πεδίου"/>
            </div>
            <div class="controls">
                <select class="form-select" bind:value="{ editField.field_type_id }" on:change="{ save }" disabled="{ editField.lock_field_type_id > 0 }">
                    {#each SERVICE_CUSTOM_FIELDS as type, index}
                        <option value="{ index }">{ type }</option>
                    {/each}
                </select>
            </div>
        {:else}
            <div class="field-content border-after">
                <div class="name" on:click="{ onEdit }">{ field.name }</div>
            </div>
            <div class="field-controls">
                <div>{ SERVICE_CUSTOM_FIELDS[field.field_type_id] }</div>
                <div class="control border-after">
                    <Icon name="arrows-v" size="16"/>
                </div>
                <div class="control" on:click="{ onDelete }">
                    <Icon name="trash" size="16"/>
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .field {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: var(--default-border);
    }

    .field-content {
        width: 100%;
    }

    .field-content .name {
        padding: 10px;
        cursor: pointer;
    }

    .field-controls {
        display: flex;
        align-items: center;
    }

    .field-controls .control {
        cursor: pointer;
        /*background: #ccc;*/
        padding: 5px 5px;
    }
</style>